module.exports = __webpack_public_path__ + "img/channel-talk.81ac2316.png";